import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat.js';

dayjs.extend(utc);
dayjs.extend(customParseFormat);

const formatDate = (
  dateString: string,
  withTime = false,
  formatString = 'DD/MM/YYYY',
  dateStringFormat: string | null = null
) => {
  let date = dateStringFormat ? dayjs(dateString, dateStringFormat) : dayjs(dateString);

  // tack on UTC/local conversion after the variable
  date = date.utc(true).local();

  const finalFormat = withTime ? `${formatString} hh:mm A` : formatString;

  return date.format(finalFormat);
};

export default formatDate;
